import { ContactRequestError, contactErrorKey } from "./contactErrors";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
if (!backendUrl) throw new Error("REACT_APP_BACKEND_URL is required");

export async function contactRequest(path, data, csrfToken) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 45000);
  try {
    const response = await fetch(`${backendUrl}/api/contact${path}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json", "X-Orico-Origin": window.location.origin,
        ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}) },
      ...(data ? { body: JSON.stringify(data) } : {}),
      signal: controller.signal,
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new ContactRequestError(contactErrorKey(response.status, result.detail));
    }
    return result;
  } catch (error) {
    if (error.name === "AbortError" || error instanceof TypeError) {
      throw new ContactRequestError("network");
    }
    throw error;
  } finally {
    clearTimeout(timeout);
  }
}
